import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/plugins/jwtService";
import { requestInterceptor, responseSuccess, responseError } from "@/plugins/interceptorsHandler";

const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        Vue.axios.interceptors.request.use(requestInterceptor);
        Vue.axios.interceptors.response.use(responseSuccess, responseError)
        axios.interceptors.request.use(requestInterceptor)
        axios.interceptors.response.use(responseSuccess, responseError)

    },


    send(url, method, params = [], data = []) {

        return axios({
            url,
            method, // default
            baseURL: process.env.VUE_APP_API_URL,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': `Bearer ${JwtService.getToken()}`
            },
            params,
            data,
            timeout: 0, // default is `0` (no timeout)

        })

    },

    setHeader() {
        Vue.axios.defaults.headers.common["Authorization"] = `Bearer ${JwtService.getToken()}`;
        Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

        return this
    },

    query(resource, params) {
        this.setHeader()
        return Vue.axios.get(resource, params).catch(error => {
            //console.log(`[RWV] ApiService ${error}`);
        });
    },

    get(resource, slug = "") {
        this.setHeader()
        return Vue.axios.get(`${resource}/${slug}`).catch(error => {
            console.log(`[RWV] ApiService ${error}`);
        });
    },

    post(resource, params) {
        this.setHeader()
        return Vue.axios.post(`${resource}`, params);
    },

    update(resource, slug, params) {
        this.setHeader()
        return Vue.axios.put(`${resource}/${slug}`, params);
    },

    put(resource, params) {
        this.setHeader()
        return Vue.axios.put(`${resource}`, params).catch(error => {
            console.log(`[RWV] ApiService ${error}`);
        });
    },

    axios(mode, resource, data) {
        return Vue.axios({
            method: (mode) ?
                'PUT' : 'POST',
            url: resource,
            data: data
        })

    },

    delete(resource, params) {
        this.setHeader()
        return Vue.axios.delete(resource, { data: params }).catch(error => {
            console.log(`[RWV] ApiService ${error}`);
        });
    }
};

export default ApiService;